<template>

	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">

		<h4>Tarieven</h4>  
		
		<c-table
            ref="table"
			:columns="columns"
			:endpoint="endpoint"
			:search="false"
            @reload="reload">
		</c-table>

		<div class="flex">
			<div class="c-prenotification__button margin-r-8" @click="trigger('monthly-payments')">
				<button class="c-btn c-btn--hollow no-margin">
					+ Vaste bedragen
				</button>
			</div>

			<div class="c-prenotification__button" @click="trigger('generate-invoice')">
				<button class="c-btn c-btn--hollow no-margin">
					Genereer factuur
				</button>
			</div>
		</div>
	</div>

</template>

<script>
import CTable from '@components/table/Table';

export default {
	components: { CTable },
	props: {
		endpoint: {
			required: true,
		},
		client_type_id: {
			required: true,
		}
	},
    methods: {
        reload(){
            this.$refs.table.load();
        },
		trigger(event) {
           this.$store.dispatch('listener/emit', event);
		}
    },
	computed: {
		columns() {
            return  [
                { name: 'name', label: 'Productnaam'},
                { name: 'article_number', label: 'Artikelnr' },
                { name: 'price.price', label: 'Prijs', component: 'CColumnPrice'},
                { name: 'id', label: '', component: 'CColumnChangePrice', props: {emit: 'openModal'}},
            ];
		},
	},
    created() {
		this.$store.dispatch('listener/on', {
			event: 'reload-prices',
			listener: this.reload
		});
    },
    beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'reload-prices',
			listener: this.reload
		});
    }
}
</script>
